const NO_CHANGES_MESSAGE = "no changes";

export const isNoChangesMessage = (message: string | null | undefined): boolean =>
	!!message?.toLowerCase().includes(NO_CHANGES_MESSAGE);

// RTK Query transport errors are always objects, so an array here is runForResult's conflated payload errors, not a transport failure.
const isTransportFailure = (error: unknown): boolean => !!error && !Array.isArray(error);

const isNoChangesError = (
	transportError: unknown,
	errors: ReadonlyArray<{ message?: string | null } | null> | null | undefined
): boolean => !isTransportFailure(transportError) && !!errors?.some((error) => isNoChangesMessage(error?.message));

export const isEntityNoChangesError = (
	transportError: unknown,
	errors: ReadonlyArray<{ code?: string | null; message?: string | null } | null> | null | undefined
): boolean => !transportError && !!errors?.length && errors.every((error) => error?.code === "ENTITY_NO_CHANGES");

export default isNoChangesError;
